import React, { useCallback } from 'react';
import { useGlobalTheme } from '@atlaskit/theme/components';
import { Wrapper } from './styled';
export const Frame = props => {
  const {
    isSelected,
    children,
    onClick,
    link,
    withoutBackground,
    withoutHover,
    testId,
    className
  } = props;
  const handleClick = useCallback(event => {
    if (onClick) {
      event.preventDefault();
      event.stopPropagation();
      onClick(event);
    }
  }, [onClick]);
  const handleKeyPress = useCallback(event => {
    if (event.key !== ' ' && event.key !== 'Enter') {
      return;
    }

    if (onClick) {
      event.preventDefault();
      event.stopPropagation();
      onClick(event);
    }
  }, [onClick]);
  const isInteractive = Boolean(onClick); // TODO Theming doesn't work right now in editor. Required React context does not trickle down atm.
  //  It will be worked as part of https://product-fabric.atlassian.net/jira/servicedesk/projects/DTR/queues/issue/DTR-154

  return /*#__PURE__*/React.createElement(Wrapper, {
    theme: useGlobalTheme(),
    href: link,
    withoutBackground: withoutBackground,
    withoutHover: withoutHover,
    isSelected: isSelected,
    isInteractive: isInteractive,
    tabIndex: isInteractive ? 0 : undefined,
    role: isInteractive ? 'button' : undefined,
    onClick: handleClick,
    onKeyPress: handleKeyPress,
    "data-testid": testId,
    className: className
  }, children);
};